import { queryOptions } from "@tanstack/react-query";

import { getCancelPreview } from "../services/getCancelPreview";

const cancelPreviewKeys = {
  root: ["cancelPreview"] as const,
  bySessionCode: (sessionCode: string) =>
    [...cancelPreviewKeys.root, "detail", sessionCode] as const,
};

export const cancelPreviewQuery = (sessionCode: string) =>
  queryOptions({
    queryKey: cancelPreviewKeys.bySessionCode(sessionCode),
    queryFn: () => getCancelPreview(sessionCode),
  });
